import applepay from '@/assets/sounds/applepay.mp3';
import iphoneGlass from '@/assets/sounds/iphone-glass.mp3';
import iphoneNotification from '@/assets/sounds/iphone_notification.mp3';
import iphoneV3 from '@/assets/sounds/iphoneV3.mp3';
import bmwBong from '@/assets/sounds/bmw-bong.mp3';
import discord from '@/assets/sounds/discord.mp3';

export interface INotificationSound {
  id: string;
  label: string;
  src: string;
}

/**
 * Реестр доступных мелодий уведомления о новом заказе.
 * Добавить/убрать мелодию — одной записью в этом массиве.
 */
export const NOTIFICATION_SOUNDS: INotificationSound[] = [
  { id: 'applepay', label: 'Звук 1', src: applepay },
  { id: 'iphone-glass', label: 'Звук 2', src: iphoneGlass },
  { id: 'iphone-notification', label: 'Звук 3', src: iphoneNotification },
  { id: 'iphone-v3', label: 'Звук 4', src: iphoneV3 },
  { id: 'bmw-bong', label: 'Звук 5', src: bmwBong },
  { id: 'discord', label: 'Звук 6', src: discord }
];

export const DEFAULT_SOUND_ID = NOTIFICATION_SOUNDS[0].id;

export const DEFAULT_SOUND_VOLUME = 0.5;

/**
 * Возвращает мелодию по её id или дефолтную, если id не найден в реестре.
 *
 * @param soundId - id искомой мелодии
 * @returns найденная мелодия либо первая (дефолтная) из реестра
 */
export const getNotificationSound = (soundId: string): INotificationSound =>
  NOTIFICATION_SOUNDS.find((sound) => sound.id === soundId) ??
  NOTIFICATION_SOUNDS[0];
